export default "__VITE_ASSET__0TozZ72C__"